import "../../css/userPage/PaymentList.css";
import Pagination from "../footer/Pagination";
import { useEffect, useState } from "react";
import { getDateString } from "../../utils/Utils";
import proxy from "../../utils/Proxy";
import PaymentMethods from "../../utils/constants/PaymentMethods";
import HoldingStatus from "../../utils/constants/HoldingStatus";
import { useMediaQuery } from "react-responsive";
import PaymentHoldingModal from "./PaymentHoldingModal";

let PaymentList = (props) => {
    let [payments, setPayments] = useState([])
    let [listLength, setListLength] = useState(0)
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const ElementCountInOnePage = 10
    
    let [holdingModalOpen, setHoldingModalOpen] = useState(false);
    let [selectedPayment, setSelectedPayment] = useState(null);

    let setPage = (page) => {
        props.onCurrentPageChange(page)
    }

    let getPaymentMethodName = (method) => {
        return PaymentMethods.getPaymentMethodTexts(method);
    }

    let isPaymentActive = (payment) => {
        // 환불되지 않았는지 확인
        if (payment.refunded) {
            return false;
        }
        
        // startdate_non_set이 true인 경우 활성화되지 않음
        if (payment.startdate_non_set) {
            return false;
        }
        
        // start와 end가 설정되어 있는지 확인
        if (!payment.start || !payment.end) {
            return false;
        }
        
        // 현재 날짜가 start와 end 사이에 있는지 확인
        const currentDate = new Date();
        const startDate = new Date(payment.start);
        const endDate = new Date(payment.end);
        
        return currentDate >= startDate && currentDate <= endDate;
    }

    let handleHoldingSuccess = () => {
        props.onUpdate();
    };

    let handleHoldingCancel = async (holdingid) => {
        if (!window.confirm("홀딩 신청을 취소하시겠습니까?")) {
            return;
        }

        try {
            const response = await proxy.delete(`/api/holdings/${holdingid}`);
            if (response.status === 200) {
                window.alert("홀딩 신청이 취소되었습니다.");
                props.onUpdate();
            } else {
                window.alert("홀딩 취소에 실패했습니다.");
            }
        } catch (error) {
            console.error("홀딩 취소 실패:", error);
            if (error.response?.status === 406) {
                window.alert("대기중인 홀딩만 취소할 수 있습니다.");
            } else {
                window.alert("홀딩 취소 중 오류가 발생했습니다.");
            }
        }
    };

    let getHoldingsInfo = (payment) => {
        if (!payment.holdings || payment.holdings.length === 0) {
            return <span className="no-holdings">홀딩 없음</span>;
        }
        
        return (
            <div className="holdings-info">
                {payment.holdings.map((holding, index) => (
                    <div key={holding.holdingid} className="holding-period">
                        {getDateString(new Date(holding.holding_start))} ~ {getDateString(new Date(holding.holding_end))}
                        <span className={`holding-status ${HoldingStatus.getStatusClass(holding.is_resolved)}`}>
                            {HoldingStatus.getStatusText(holding.is_resolved)}
                        </span>
                        {holding.is_resolved === HoldingStatus.PENDING && (
                            <button 
                                className="holding-cancel-button"
                                onClick={() => handleHoldingCancel(holding.holdingid)}
                                title="홀딩 취소"
                            >
                                x
                            </button>
                        )}
                        {index < payment.holdings.length - 1 && <br />}
                    </div>
                ))}
            </div>
        );
    }

    let getMobileHoldingsInfo = (payment) => {
        if (!payment.holdings || payment.holdings.length === 0) {
            return <span className="payment-mobile-no-holdings">홀딩 없음</span>;
        }
        
        return (
            <div className="payment-mobile-holdings">
                {payment.holdings.map((holding, index) => (
                    <div key={holding.holdingid} className="payment-mobile-holding-period">
                        {getDateString(new Date(holding.holding_start))} ~ {getDateString(new Date(holding.holding_end))}
                        <span className={`holding-status ${HoldingStatus.getStatusClass(holding.is_resolved)}`}>
                            {HoldingStatus.getStatusText(holding.is_resolved)}
                        </span>
                        {holding.is_resolved === HoldingStatus.PENDING && (
                            <button 
                                className="holding-cancel-button-mobile"
                                onClick={() => handleHoldingCancel(holding.holdingid)}
                                title="홀딩 취소"
                            >
                                ×
                            </button>
                        )}
                        {index < payment.holdings.length - 1 && <br />}
                    </div>
                ))}
            </div>
        );
    }

    let handleHoldingClick = (payment) => {
        setSelectedPayment(payment);
        setHoldingModalOpen(true);
    };

    let handleHoldingModalClose = () => {
        setHoldingModalOpen(false);
        setSelectedPayment(null);
    };

    let getPaymentRows = () => {
        if (payments.length === 0) {
            return [];
        }
        
        let ret = [];
        for (let payment of payments) {
            let key = "paymentid:" + payment.paymentid;
            ret.push(
                <div className="payment-history-data-row" key={key}>
                    <div className="payment-element-cell payment-user-column-date">
                        <p>{getDateString(new Date(payment.payment_date))}</p>
                    </div>
                    <div className="payment-element-cell payment-user-column-amount">
                        <p>{payment.payment_amount.toLocaleString()}원</p>
                    </div>
                    <div className="payment-element-cell payment-user-column-method">
                        <p>{getPaymentMethodName(payment.method)}</p>
                    </div>
                    <div className="payment-element-cell payment-user-column-period">
                        <p>
                            {payment.startdate_non_set ? "미설정" : 
                             `${getDateString(new Date(payment.start))} ~ ${getDateString(new Date(payment.end))}`}
                        </p>
                    </div>
                    <div className="payment-element-cell payment-user-column-holdings">
                        {getHoldingsInfo(payment)}
                        {isPaymentActive(payment) && (
                            <button 
                                className="payment-holding-button"
                                onClick={() => handleHoldingClick(payment)}
                            >
                                홀딩 신청
                            </button>
                        )}
                    </div>
                    <div className="payment-element-cell payment-user-column-status">
                        <p className={payment.refunded ? "refunded" : "active"}>
                            {payment.refunded ? "환불됨" : "결제됨"}
                        </p>
                    </div>
                </div>
            );
        }
        return ret;
    }

    let getMobileCards = () => {
        if (payments.length === 0) {
            return [];
        }
        
        let ret = [];
        for (let payment of payments) {
            let key = "mobile-paymentid:" + payment.paymentid;
            ret.push(
                <div className="payment-mobile-card" key={key}>
                    <div className="payment-mobile-header">
                        <div className="payment-mobile-date">
                            {getDateString(new Date(payment.payment_date))}
                        </div>
                        <div className="payment-mobile-amount">
                            {payment.payment_amount.toLocaleString()}원
                        </div>
                    </div>
                    <div className="payment-mobile-content">
                        <div className="payment-mobile-row">
                            <div className="payment-mobile-label">수강기간</div>
                            <div className="payment-mobile-value">
                                {payment.startdate_non_set ? "미설정" : 
                                 `${getDateString(new Date(payment.start))} ~ ${getDateString(new Date(payment.end))}`}
                            </div>
                        </div>
                        <div className="payment-mobile-row">
                            <div className="payment-mobile-label">홀딩 정보</div>
                            <div className="payment-mobile-value">
                                {getMobileHoldingsInfo(payment)}
                            </div>
                        </div>
                        {isPaymentActive(payment) && (
                            <div className="payment-mobile-row">
                                <div className="payment-mobile-label"></div>
                                <div className="payment-mobile-value">
                                    <button 
                                        className="payment-holding-button-mobile"
                                        onClick={() => handleHoldingClick(payment)}
                                    >
                                        홀딩 신청
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            );
        }
        return ret;
    }

    useEffect(() => {
        let params = {
            page: props.currentPage,
            count: ElementCountInOnePage
        };
        
        proxy.get("/api/payments", { params: params }).then(res => {
            let data = res.data.data;
            setListLength(res.data.totalLength || data.length);
            setPayments(data);
            props.onUpdate();
        }).catch(err => {
            console.error("결제 내역 조회 실패:", err);
            window.alert("결제 내역을 불러오는데 실패했습니다.");
        });
    }, [props.currentPage, props.needUpdate])

    return (
        <div className="payment-history-container">
            
            {/* 데스크톱 테이블 */}
            <div className="payment-history-table-container">
                <div className="payment-history-table">
                    <div className="payment-list-table-header">
                        <div className="payment-history-header-row">
                            <div className="payment-element-cell payment-user-column-date">
                                <p>결제일</p>
                            </div>
                            <div className="payment-element-cell payment-user-column-amount">
                                <p>결제금액</p>
                            </div>
                            <div className="payment-element-cell payment-user-column-method">
                                <p>결제방법</p>
                            </div>
                            <div className="payment-element-cell payment-user-column-period">
                                <p>수강기간</p>
                            </div>
                            <div className="payment-element-cell payment-user-column-holdings">
                                <p>홀딩 정보</p>
                            </div>
                            <div className="payment-element-cell payment-user-column-status">
                                <p>상태</p>
                            </div>
                        </div>
                    </div>
                    {getPaymentRows()}
                </div>
            </div>
            {
                isMobile ? (
                    <div className="payment-history-mobile-container">
                        {getMobileCards()}
                    </div>
                ) : (
                    null
                )
            }
            
            <Pagination 
                page={props.currentPage} 
                setPage={setPage}
                listLength={listLength} 
                countPerPage={ElementCountInOnePage} 
            />

            {/* 홀딩 설정 모달 */}
            {holdingModalOpen && selectedPayment && (
                <PaymentHoldingModal
                    needUpdate={props.needUpdate}
                    setNeedUpdate={props.setNeedUpdate}
                    payment={selectedPayment}
                    onClose={handleHoldingModalClose}
                    onSuccess={handleHoldingSuccess}
                />
            )}
        </div>
    )
};

export default PaymentList; 